<template>
  <div v-if="task">
    <task-body
      :task="task"
      :try-join="tryJoin"
      :try-leave="tryLeave"
      :joined="joinBtnState"
      :join-pending="joinPending"
      :user-left="userLeft"
      :user-rejected="userRejected"
      :rejected-reason="rejectedReason"
      :participant="participant"
    />
    <box>
      <masonry :cols="{ default: 2, 992: 1 }" :gutter="20">
        <reward-custom
          v-for="(reward, index) in task.rewards"
          :key="index"
          v-model="task.rewards[index]"
          header-class="creative-color"
          class="mb-4"
          no-limits
        />
      </masonry>
    </box>
    <b-modal
      ref="beforeJoinModal"
      centered
      size="lg"
      title="Describe your offer"
      title-tag="h2"
      ok-title="Send request"
      @ok="join"
    >
      <b-form>
        <vue-editor
          class="ct-editor"
          v-model="editor.desc"
          :editor-toolbar="editor.customToolbar"
        />
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardCustom from '@/components/RewardCustom.vue';

export default {
  mixins: [taskMixin],

  components: { RewardCustom },

  data() {
    return {
      editor: {
        desc: null,
        editorSettings: this.$config.defaultEditorSettings.editorSettings,
        customToolbar: this.$config.defaultEditorSettings.customToolbar
      }
    };
  },

  methods: {
    tryJoin() {
      Promise.resolve(true).then(res => {
        // if (res) this.$refs.beforeJoinModal.show();
        if (res) this.join();
        else this.showReject();
      });
    }
    // join(e) {
    //   e.preventDefault();
    //   // TODO: add spiner when request is status sending
    //
    //   Promise.resolve(true).then(res => {
    //     if (res) {
    //       this.$refs.beforeJoinModal.hide();
    //       this.$bus.$emit('modal:info', {
    //         title:
    //           'Thank You. Our Manager is going to check the application and You will receive an email with further details.',
    //         size: 'md'
    //       });
    //     } else {
    //       // TODO: show errors
    //     }
    //   });
    // }
  }
};
</script>
